import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// --- NEW: Thematic Icons for a Travel Map ---
// We'll use a more fitting icon for cities on our special map.
// You can find icons on sites like flaticon.com or use your own.
const cityIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/2933/2933222.png', // A nice, simple location pin
  iconSize: [35, 35],
  iconAnchor: [17, 35],
  popupAnchor: [0, -35],
});


const SriLankaMap = () => {
  const mapboxAccessToken = 'pk.eyJ1IjoidGhldmludSIsImEiOiJjbThvbjV5d3MwMjAxMmlwb2tzNWM3a3g5In0.dcO6tchrc906QWoV36PMxQ';

  // --- STYLE SWITCHER ---
  // Choose your map's look here. Just copy/paste one of the style IDs.
  // -------------------------------------------------------------------------
  // Option 1: Adventurer's Map (Recommended for travel)
  const mapStyleId = 'mapbox/outdoors-v12';
  
  // Option 2: Vintage Antique Map
  // const mapStyleId = 'caguilar/cl3nw5v1c001q14o12v8afn6q';

  // Option 3: Elegant Dark Mode
  // const mapStyleId = 'mapbox/dark-v11';

  // Option 4: Realistic Satellite View
  // const mapStyleId = 'mapbox/satellite-streets-v12';
  
  // Option 5: Default Streets (what you had before)
  // const mapStyleId = 'mapbox/streets-v11';
  // -------------------------------------------------------------------------

  if (!mapboxAccessToken || mapboxAccessToken === 'YOUR_MAPBOX_ACCESS_TOKEN') {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f0f0f0' }}>
        <h2 style={{ color: '#d9534f', fontFamily: 'sans-serif' }}>
          Error: Mapbox Access Token is not set. Please add your token.
        </h2>
      </div>
    );
  }
  
  const centerPosition = [7.8731, 80.7718];
  const initialZoom = 8;
  const bounds = L.latLngBounds(L.latLng(5.9, 79.5), L.latLng(9.9, 82.0));

  const cities = [
    { name: 'Colombo', position: [6.9271, 79.8612], info: 'The commercial capital and largest city.' },
    { name: 'Kandy', position: [7.2906, 80.6337], info: 'Home to the Temple of the Tooth Relic.' },
    { name: 'Galle', position: [6.0535, 80.2210], info: 'Known for its beautiful fort, a UNESCO World Heritage Site.' },
    { name: 'Jaffna', position: [9.6615, 80.0255], info: 'The cultural capital of the Tamil people.' },
    { name: 'Nuwara Eliya', position: [6.9497, 80.7891], info: 'The "Little England" of Sri Lanka, famous for tea plantations.' },
    { name: 'Sigiriya', position: [7.9575, 80.7602], info: 'Ancient rock fortress with magnificent frescoes.' },
    { name: 'Anuradhapura', position: [8.3459, 80.3878], info: 'An ancient capital, famous for its well-preserved ruins.' }
  ];

  return (
    <MapContainer
      center={centerPosition}
      zoom={initialZoom}
      style={{ height: "100vh", width: "100%" }}
      scrollWheelZoom={true}
      maxBounds={bounds}
      minZoom={7}
    >
      <TileLayer
        // The URL now uses our mapStyleId variable
        url={`https://api.mapbox.com/styles/v1/${mapStyleId}/tiles/{z}/{x}/{y}?access_token=${mapboxAccessToken}`}
        attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
      />

      {cities.map(city => (
        <Marker 
          key={city.name} 
          position={city.position} 
          // Use our new custom icon!
          icon={cityIcon}
        >
          <Popup>
            <h3>{city.name}</h3>
            <p>{city.info}</p>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default SriLankaMap;